import { makeStyles } from 'tss-react/mui';

export const useAttributeStyles = makeStyles()(() => ({
  inlineBlockNormalStyle: {
    display: 'inline-block',
    fontWeight: 'normal',
  },
  inlineBlockBoldStyle: { display: 'inline-block', fontWeight: 'bold' },
  marginBottom05RemStyle: { marginBottom: '0.5rem' },
  noDecorationLink: {
    textDecoration: 'none',
  },
}));
